import { t } from '../../../locales';
import { featureFlag } from '../../entities/feature-flag';
import StudentRegistrationsHeaderButtons from './pages/registration-responses/components/header-buttons.vue';

const kodoratAgentRoutes = {
	path: 'education',
	component: () => import('./module-layout.vue'),
	meta: {
		featureFlag: featureFlag.EDUCATION,
	},
	children: [
		{
			path: 'registration-responses',
			component: () => import('./pages/registration-responses/index.vue'),
			meta: {
				title: t('education.students-registrations'),
				headerExtraComponent: StudentRegistrationsHeaderButtons,
			},
		},
		{
			path: 'academy-data',
			component: () => import('./pages/academy-data/index.vue'),
			meta: {
				title: t('education.academy-data'),
			},
		},
		{
			path: 'diplomas/create',
			component: () => import('./pages/diploma-editor/index.vue'),
			meta: {
				title: t('education.academy-data'),
			},
		},
		{
			path: 'diplomas/update/:id',
			component: () => import('./pages/diploma-editor/index.vue'),
			props: true,
			meta: {
				title: t('education.academy-data'),
			},
		},
	],
};

export { kodoratAgentRoutes };
